import React, { useEffect, useRef, useState } from "react";
import ScrollToHomeButton from "./ScrollToHomeButton";
import { FcGoogle } from "react-icons/fc";

const reviews = [
  {
    name: "Asha Bharathi",
    review:
      "I've joined this institute for advanced video editing course. Course syllabus was quite good. Thanks to Akram Khan sir.. who teached us these concepts very clearly and patiently. Sanyuktha ma'am was always there for any query at any time.",
  },
  {
    name: "Naresh Chintawar",
    review:
      "This is the best place to learn Animation, VFX, graphics designing and other courses. Teachers are very friendly and they give you so much information about your course and career. Their teaching style is excellent you will understand it easily.",
  },
  {
    name: "Somya Das",
    review:
      "I have attended 3D Blender Course from Haptic Realities. The faculty is very knowledgeable. The assignments helped us complete our Portfolio, very important for job search. Best faculty for 3D!",
  },
  {
    name: "Nupur Chaudhary",
    review:
      "Haptic Realities is a wonderful training institute in Hyderabad. Their Graphic Designing course helped me build an impressive designer portfolio. The Faculty is very cooperative and competent.",
  },
  {
    name: "Shipra Dutta",
    review:
      "I came across Haptic Realities for my sister's graphic designing course. The faculty is extremely friendly and helpful. The course is well structured, and my sister could understand from basics to advanced.",
  },
  {
    name: "Balaji Das",
    review:
      "I have searched many institutes for Zbrush classes and finally joined online Zbrush class at Haptic Realities. The faculty is very knowledgeable and friendly, explained many ways to create 3D models. Very useful for CNC carving.",
  },
  {
    name: "Priyanka Priya",
    review:
      "I had taken the online Zbrush course from Haptic Realities. Sir taught with real industry scenarios, making it easy to understand. Best faculty for Zbrush course in Hyderabad!",
  },
  {
    name: "Lifestyle Srikanth Reddy",
    review:
      "Haptic Realities is a good institute to learn visual effects and animation. I took an online course after a lot of research and gained great practical knowledge.",
  },
  {
    name: "Vineeth Kumar",
    review:
      "I have worked with the team for the last several years, and they have consistently delivered great results. Appreciate Sanyukta and team for proposing innovative solutions.",
  },
  {
    name: "Tanay Kabra",
    review:
      "Most experienced and professional trainers. You get support until you succeed. Highly recommend it for technical and skill development.",
  },
  {
    name: "Himanshu Soni",
    review:
      "I am from Madhya Pradesh and taking online training. This academy is very good for all creative learners. I am fully satisfied.",
  },
  {
    name: "Deepak Rai",
    review:
      "Best faculty with real-time industry experience. They offer both online and offline training. Highly recommend joining for a better future.",
  },
  {
    name: "Kantilal Nandeda",
    review:
      "I have taken the online VFX course from Haptic Realities Animation and VFX Training Center. Very knowledgeable and helpful faculty. I joined to upgrade my skills.",
  },
  {
    name: "Santosh Mallick",
    review:
      "I recently completed the Unity course at Haptic Realities. Sai sir was very helpful and approachable. Overall, a great learning experience.",
  },
  {
    name: "Balram Singh Chouhan",
    review:
      "The Specialization builds skills necessary for game design and development, focusing on both theory and practice of game making. Excellent course structure.",
  },
  {
    name: "Gaurav C",
    review:
      "They have knowledgeable professionals and well-trained faculties. One of the leading animation institutes in Hyderabad.",
  },
  {
    name: "Akhil _004",
    review:
      "This was my first time taking online classes and I had a great experience. Learned a lot of new skills through simple and easy teaching methods.",
  },
  {
    name: "Piyush Bairagi",
    review:
      "An amazing institute with the best faculties. They cleared every doubt and helped me groom my skills. Thank you, Haptic Realities!",
  },
  {
    name: "Sucharita Pal",
    review:
      "The best place to learn graphics and animation. Akram sir helped me a lot throughout my learning process.",
  },
  {
    name: "Abhishek Kanth",
    review:
      "Very structured courses and experienced faculties for Blender and Zbrush. Very happy with the training.",
  },
  {
    name: "Ch Girikoushik",
    review:
      "Good place to learn VFX and Gaming. Lead trainers with updated technology and industry-standard training. Best place to build your career.",
  },
  {
    name: "Sonika Jain",
    review:
      "One of the best academies in Hyderabad which makes your future bright.",
  },
  {
    name: "Arun Osatwal",
    review:
      "Very professional staff and cooperative. Next-level training in gaming, animation, and VFX, especially in offline mode.",
  },
  {
    name: "Sanjay Samant",
    review: "Very good 3D animation and VFX training and mentorship.",
  },
  {
    name: "Vivek Anand",
    review: "Good.",
  },
  {
    name: "Ram Gupta",
    review:
      "Very helpful and enriching experience. Well done, guys! Keep up the good work.",
  },
  {
    name: "Ashish Singh",
    review:
      "It's a good place for 3D animation and VFX training and mentorship.",
  },
];

const StudentComments = () => {
  const scrollRef = useRef();
  const [autoScroll, setAutoScroll] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoScroll && scrollRef.current) {
        if (
          scrollRef.current.scrollLeft + scrollRef.current.clientWidth >=
          scrollRef.current.scrollWidth
        ) {
          scrollRef.current.scrollLeft = 0; // reset to start when reached end
        } else {
          scrollRef.current.scrollLeft += 1; // continue scrolling
        }
      }
    }, 20);

    return () => clearInterval(interval);
  }, [autoScroll]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const amount = 300;
      if (direction === "left") {
        scrollRef.current.scrollLeft -= amount;
      } else {
        scrollRef.current.scrollLeft += amount;
      }
    }
  };

  return (
    <>
      <section
        id="comments"
        className="flex flex-col items-center bg-[#090522] py-6 px-6 relative -mt-8"
      >
        <h2 className="text-3xl text-yellow-400 font-bold mb-8">
          <span className="text-orange-500">STUDENT</span> REVIEWS
        </h2>{" "}
        <a
          href="https://g.co/kgs/hjFDVCA"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex pb-6 items-center text-white hover:text-yellow-400"
        >
          Click to check the reviews at <FcGoogle className="ml-2 text-xl" />
        </a>
        <div className="relative w-full max-w-6xl">
          {/* Scroll Buttons */}
          <button
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10"
          >
            ◀️
          </button>
          <button
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10"
          >
            ▶️
          </button>

          {/* Reviews */}
          <div
            ref={scrollRef}
            className="flex space-x-6 overflow-x-hidden py-2 px-2"
            onMouseEnter={() => setAutoScroll(false)}
            onMouseLeave={() => setAutoScroll(true)}
          >
            {reviews.map((item, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-80 bg-white rounded-xl shadow-md p-6"
              >
                <div className="flex items-center mb-2">
                  {/* User Icon */}
                  <svg
                    className="w-6 h-6 text-blue-500 mr-2"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
                  </svg>
                  <h3 className="text-lg font-semibold">{item.name}</h3>
                </div>
                <p className="text-gray-600 text-sm">{item.review}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Button Section */}
      <ScrollToHomeButton />
    </>
  );
};

export default StudentComments;
